import columns from '../../../../react-table/helpers/columns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export function getEditPage(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/balance-on-hand-thresholds-edit',
    tableId: TableDefinitions.BALANCE_ON_HAND_THRESHOLDS_PAGE.id,
    text: 'Edit Min/Max',
  } : {};
}

export default (data, userType) => {
  const {
    DateTimeColumn,
    NumberColumn,
    EditButtonColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new NumberColumn('Week number', 'weekNo'),
        new NumberColumn('Min', 'minThreshold'),
        new NumberColumn('Max', 'maxThreshold'),
        new DateTimeColumn('Last modified', 'lastUpdateDate'),
        new NavigationColumn(new EditButtonColumn('Edit action', '', '', 'Edit Min/Max').withShow(userType.includes('IPC')), getEditPage),
      ],
    },
  ];
};
